import React from "react";
import PropTypes from "prop-types";
import "./style.scss";

/**
 * AnimationWrapper:
 * - The wrapper component for Lottie Animation component.
 */
export function AnimationWrapper(props) {
  const wrapperClass = () =>
    ["animationWrapper", props.hidden ? "hidden" : ""].join(" ");

  return <div className={wrapperClass()}>{props.children}</div>;
}

AnimationWrapper.propTypes = {
  /**
   * Boolean to set is animation is hidden
   */
  hidden: PropTypes.bool.isRequired,
  /**
   * Contents to be displayed inside Animation wrapper
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

AnimationWrapper.defaultProps = {
  hidden: false,
};
